import * as React from "react"

import {LoadingIndicatorIcon} from "components/shared/icons"
import {twMerge} from "libs/twmerge"

/**
 * @typedef {object} V3SubmitButtonProps
 * @property {React.ReactNode} children
 * @property {boolean} [loading]
 */

/**
 * @type {React.FC<V3SubmitButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>>}
 */
const V3SubmitButton = ({
  children,
  className = "",
  disabled,
  loading = false,
  type = "submit",
  ...restProps
}) => (
  <button
    {...restProps}
    type={type}
    disabled={disabled || loading}
    className={twMerge(
      "inline-flex h-[40px] min-h-[40px] w-[120px] items-center justify-center gap-[6px] rounded-[24px] bg-neutral-black px-4 text-center font-action text-[14px] font-extrabold not-italic leading-4 text-neutral-white capitalize disabled:opacity-50 lg:min-w-[120px]",
      className,
    )}
  >
    <span className="inline-block translate-y-px">{children}</span>
    {loading ? (
      <LoadingIndicatorIcon className="h-[14px] w-[14px] shrink-0 animate-spin" />
    ) : null}
  </button>
)

export default V3SubmitButton
